import { JsonRpcSigner } from 'ethers';

export async function requestNetworkChange(signer: JsonRpcSigner, networkId: any) {
  const ethereum = signer.provider;

  const currentNetwork = await signer.provider.getNetwork();

  const network: string = networkId?.toString() ?? String(networkId);

  if (currentNetwork.chainId.toString() === network) return { state: true, changed: false };

  const networkData = {
    '56': {
      name: 'BNB Smart Chain',
      currency: 'BNB',
      rpc: 'https://bsc-rpc.publicnode.com',
      explorer: 'https://bscscan.com/'
    },
    '97': {
      name: 'BNB Smart Chain Testnet',
      currency: 'tBNB',
      rpc: 'https://bsc-testnet-rpc.publicnode.com',
      explorer: 'https://testnet.bscscan.com/'
    }
  }[network];

  // WalletConnect
  //if (accountStore.selectedAccount.wallet.info.uuid === 'eip155') {
  //  await accountStore.selectedAccount.wallet.disconnect();
  //
  //  const wc = accountStore.wallets.find((e) => e.info.uuid === 'eip155');
  //
  //  if (!wc) return;
  //
  //  await wc.connect({
  //    chains: [parseInt(network.chainId.toString())]
  //  });
  //
  //  await new Promise((resolve) => setTimeout(resolve, 1000));
  //  await accountStore.updateAccounts();
  //  const wcAccount = accountStore.ethereumAccounts.find((e) => e.wallet.info.uuid === 'eip155');
  //
  //  if (!wcAccount) return;
  //
  //  accountStore.setSelectedAccount(wcAccount);
  //  await accountStore.updateAccountBalances(Address.from(wcAccount.address));
  //
  //  return;
  //}

  if (!ethereum || !networkData) return { state: false, changed: false };
  const requestChange = async () =>
    ethereum.send('wallet_switchEthereumChain', [
      { chainId: `0x${parseInt(network).toString(16)}` }
    ]) as Promise<unknown>;

  const requestInsert = async () =>
    ethereum.send('wallet_addEthereumChain', [
      {
        chainId: `0x${parseInt(network).toString(16)}`,
        chainName: 'Binance Smart Chain',
        nativeCurrency: {
          name: networkData.currency,
          symbol: networkData.currency,
          decimals: 18
        },
        rpcUrls: [networkData.rpc],
        blockExplorerUrls: [networkData.explorer]
      }
    ]) as Promise<unknown>;

  const state = !!(await requestChange().catch(async (error) => {
    console.log(error?.code);
    if (error?.code !== 4902 && error?.code !== -32603 && error?.code !== 'UNKNOWN_ERROR') return false;

    if (!(await requestInsert().catch(() => false))) return false;

    return !!(await requestChange().catch(() => false));
  }));

  return { state, changed: true };
}
